import { CLUSTER } from '@/shared/config';

// Content hub markets: the FDA subsite is `us-fda`; the Americas clusters
// (us non-FDA, ca) share the `americas` market; the international version is
// `global`; ru maps to the CIS market.
export type KbMarket = 'us-fda' | 'global' | 'americas' | 'cis';

export const getKbMarket = (isFDA: boolean): KbMarket | null => {
  switch (CLUSTER) {
    case 'us':
      return isFDA ? 'us-fda' : 'americas';
    case 'ca':
      return 'americas';
    case 'eu':
    case 'oceania':
      return 'global';
    case 'ru':
      return 'cis';
    default:
      return null;
  }
};
